// Seed the database with starter content on first run.

import { db, newId } from '../data/db';
import { toToneMark, toToneNum } from '../speech/pinyin';
import { STARTER_LESSONS } from './starterPack';
import type { Card, Lesson } from './cardSchema';

export async function seedIfEmpty(): Promise<void> {
  const lessonCount = await db.lessons.count();
  if (lessonCount > 0) return;

  const now = Date.now();
  await db.transaction('rw', db.lessons, db.cards, async () => {
    for (const sl of STARTER_LESSONS) {
      const lesson: Lesson = {
        id: sl.id,
        title: sl.title,
        source: 'starter',
        passages: sl.passages,
        zoneTheme: sl.zoneTheme,
        createdAt: now,
      };
      await db.lessons.put(lesson);

      for (const sc of sl.cards) {
        const card: Card = {
          id: newId(),
          hanzi: sc.hanzi,
          pinyin: toToneMark(sc.hanzi),
          pinyinNum: toToneNum(sc.hanzi),
          english: sc.english,
          tag: sc.tag,
          lessonId: lesson.id,
          createdAt: now,
        };
        await db.cards.put(card);
      }
    }
  });
}
